export function useFootnotes(containerRef: Ref<HTMLElement | null>) {
  function addContent(id: string, content: HTMLElement) {
    const isLabelled = content.querySelector('.footnote__label')
    if (!isLabelled) {
      const header = createFootnoteHeader(document, {
        tag: 'div',
        id,
      })

      const text = createFootnoteText(document, content)

      content.innerHTML = ''
      content.appendChild(header)
      content.appendChild(text)
    }
  }

  function toggleFootnote(btn: HTMLButtonElement) {
    const id = btn.dataset.fnId
    const footnoteContent = containerRef.value?.querySelector<HTMLElement>(`#footnote-${id}`)

    if (!footnoteContent || !id) {
      return
    }

    const isHidden = footnoteContent.hasAttribute('hidden')

    if (isHidden) {
      footnoteContent.removeAttribute('hidden')
      btn.setAttribute('aria-expanded', 'true')
      addContent(id, footnoteContent)
    }
    else {
      footnoteContent.setAttribute('hidden', '')
      btn.setAttribute('aria-expanded', 'false')
    }
  }

  function onFootnoteClick(event: Event) {
    if (!(event.target instanceof HTMLElement || event.target instanceof SVGElement)) {
      return
    }
    const target = event.target

    const footnoteButton = target.closest('button.footnote__btn') as HTMLButtonElement | null
    if (footnoteButton?.dataset.fnId) {
      toggleFootnote(footnoteButton)
    }

    const closeButton = target.closest('button.footnote__close-btn') as HTMLButtonElement | null
    if (closeButton?.dataset.footnoteId) {
      const footnoteButton = containerRef.value?.querySelector<HTMLButtonElement>(`button[data-fn-id="${closeButton.dataset.footnoteId}"]`)
      if (footnoteButton) {
        toggleFootnote(footnoteButton)
      }
    }
  }

  watch(containerRef, (el, _, onCleanup) => {
    if (!el) {
      return
    }

    el.addEventListener('click', onFootnoteClick)
    onCleanup(() => el.removeEventListener('click', onFootnoteClick))
  }, { immediate: true, flush: 'post' })

  return { addContent, toggleFootnote, onFootnoteClick }
}
